import { Navigate, useParams } from 'react-router';
import { zonePath } from '../zones.paths';

/** Old editor URLs (`/reference-data/zones/:id`, including `new`) from before zones moved to their own section — shared links keep working. */
export function RedirectToZone() {
  const { id = '' } = useParams();
  return <Navigate to={zonePath(id)} replace />;
}
